import {makeAutoObservable} from "mobx";
import {getBrowserLang, normalizeLang} from "../i18n/lang";
const LS_LANG_KEY = "app_lang";
export default class UserStore {
constructor() {
    this._isAuth = false
    this._user = {}
    this._activeComponent = "MainPageDashboard";
    this._readCountVirt = 0;
    this._readCountUsd = 0;
    this._orderstotransfervirt = [];
    this._reviewerData = null;
    // lang
    this._lang = "en";

    makeAutoObservable(this)

    // ⬇️ инициализация языка
    const savedLang = normalizeLang(localStorage.getItem(LS_LANG_KEY));
    this._lang = savedLang || getBrowserLang() || "en";
}
    setIsAuth(bool) {
        this._isAuth = bool
    }
    setUser(user) {
        this._user = user
        // ⬇️ если в профиле есть язык — можно синхронизировать
        if (user?.lang) {
            this.setLang(user.lang);
        }
    }
    // 🌍 ЯЗЫК
    setLang(nextLang) {
        const lang = normalizeLang(nextLang) || "en";
        this._lang = lang;
        localStorage.setItem(LS_LANG_KEY, lang);
    }
    setActiveComponent(component) {
        this._activeComponent = component
    }
    setReadCountVirt(count) {
        this._readCountVirt = count
    }
    setReadCountUsd(count) {
        this._readCountUsd = count
    }
    setOrderstotransfervirt(orderstotransfervirt) {
        this._orderstotransfervirt = orderstotransfervirt
    }
    setReviewerData(data) {
        this._reviewerData = data;
    }

    setBalance(balance) {
        this._balance = balance
    }

    setEmail(email) {
        this._email = email
    }

    get isAuth() {
        return this._isAuth
    }
    get user() {
        return this._user
    }
    get activeComponent() {
        return this._activeComponent
    }
    get readCountVirt() {
        return this._readCountVirt
    }
    get readCountUsd() {
        return this._readCountUsd
    }

    get email() {
        return this._email
    }

    get balance() {
        return this._balance
    }
    get reviewerData() {
        return this._reviewerData;
    }
    get orderstotransfervirt() {
        return this._orderstotransfervirt
    }
    // 🌍 ЯЗЫК
    get lang() {
        return this._lang;
    }

}